import React, {ReactElement} from 'react';
import {useHistory, useLocation} from 'react-router';
import {footerItems} from '../../lib/constants';
import './AppFooter.css';

type ListItemProps = {
  icon: string;
  onClick?: () => void;
  classes?: string;
  url: string | string[];
  active: boolean;
};

const ListItem: React.FC<ListItemProps> = (
  props: ListItemProps,
): ReactElement => {
  const {classes, onClick, icon, active} = props;
  return (
    <div className="w-10 flex justify-center">
      <li className={`${classes} my-2 ${active ? 'active-footer-li' : ''}`}>
        <div className={`${active ? ' active-footer-icon-container' : ''}`}>
          <a
            className="text-gray-400 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white transition-colors duration-200"
            onClick={onClick}>
            <img src={icon} />
          </a>
        </div>
      </li>
    </div>
  );
};
type FooterProps = {
  classNames?: string;
};

const AppFooter: React.FC<FooterProps> = (props: FooterProps): ReactElement => {
  const {classNames} = props;
  const history = useHistory();

  const isActive = (url: string | string[]): boolean => {
    if (Array.isArray(url)) {
      if (url.includes(useLocation().pathname)) {
        return true;
      }
    } else {
      return url === useLocation().pathname;
    }
    return false;
  };

  const itemClickHandler = (url: string | string[]) => {
    if (url !== '') {
      if (Array.isArray(url)) {
        history.push(url[0]);
      } else {
        history.push(url);
      }
    }
  };

  return (
    <footer className=" backdrop-blur-lg z-40 app-footer py-3 px-3 backdrop-filter dark:bg-gray-800 w-full">
      {' '}
      <div className="max-w-screen-xl mx-auto px-4 relative">
        <ul className=" max-w-screen-md mx-auto text-lg font-light flex flex-wrap justify-between">
          {footerItems.map((item, index) => (
            <ListItem
              key={index}
              icon={isActive(item.url) ? item.activeIcon : item.icon}
              url={item.url}
              active={isActive(item.url)}
              onClick={() => itemClickHandler(item.url)}
            />
          ))}
        </ul>
      </div>
    </footer>
  );
};

export default AppFooter;
